import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

const WrapperLogo = styled.div(() => ({
  flex: '0 0 auto',
  height: '40px',
  width: '40px',
}))

const StyledLogo = styled.img(({ backgroundColor, theme }) => ({
  width: '100%',
  height: '100%',
  border: `2px solid ${theme.colors.light_grey}`,
  borderRadius: '30px',
  backgroundColor,
  overflow: 'hidden',
  objectFit: 'contain',
}))

const RoundedImage = ({
  src,
  onClick,
  backgroundColor,
  dataTest,
}) => (src ? (
  <WrapperLogo onClick={onClick} data-test={dataTest || 'RoundedImage'}>
    <StyledLogo data-fallback="true" backgroundColor={backgroundColor} src={src} />
  </WrapperLogo>
) : null)

RoundedImage.propTypes = {
  src: PropTypes.string,
  onClick: PropTypes.func,
  backgroundColor: PropTypes.string,
  dataTest: PropTypes.string,
}

RoundedImage.defaultProps = {
  onClick: () => false,
  backgroundColor: null,
  src: '',
  dataTest: '',
}

RoundedImage.displayName = 'RoundedImage'
RoundedImage.whyDidYouRender = true

export default React.memo(RoundedImage)
